import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import {
  FiShield,
  FiUser,
  FiMail,
  FiPhone,
  FiLink,
  FiSend,
  FiAlertTriangle,
  FiHelpCircle,
  FiCheckSquare,
} from "react-icons/fi";
import Header from "../../components/layouts/Header";
import Footer from "../../components/layouts/Footer";
import ContactStrip from "./ContactStrip";
import "./FooterPages.css";

const Grievance = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    portal: "Mygoldenhomes.com",
    pageUrl: "",
    reason: "infringes any patent, trademark, copyright or other proprietary rights",
    details: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.email.trim() || !formData.details.trim()) {
      toast.error("Please fill in all compulsory fields");
      return;
    }
    setIsSubmitting(true);
    try {
      await new Promise((res) => setTimeout(res, 800));
      toast.success("Grievance registered. Our Grievance Officer will respond within 48 hours.", {
        position: "top-center",
        autoClose: 4000,
      });
      setFormData({
        name: "",
        email: "",
        mobile: "",
        portal: "Mygoldenhomes.com",
        pageUrl: "",
        reason: "infringes any patent, trademark, copyright or other proprietary rights",
        details: "",
      });
    } catch (err) {
      toast.error("Submission failed. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="mgh-info-page-wrapper">
      <Helmet>
        <title>Grievance Redressal Mechanism | My Golden Homes</title>
        <meta
          name="description"
          content="Grievance Redressal mechanism for consumer issues, content complaints, and compliance on My Golden Homes."
        />
      </Helmet>

      <Header />

      <section className="mgh-info-hero">
        <div className="mgh-info-hero-inner">
          <div className="mgh-info-hero-left">
            <div className="mgh-info-breadcrumb">
              <Link to="/">Home</Link>
              <span>&gt;</span>
              <span>Grievance</span>
            </div>
            <h1 className="mgh-info-hero-title">
              Grievance <span>Redressal</span>
            </h1>
            <p className="mgh-info-hero-subtitle">
              In accordance with Information Technology Act 2000 and rules made there under, the name and contact details of the Grievance Officer are provided below.
            </p>
          </div>

          <div className="mgh-info-hero-art">
            <img
              src="/assets/images/villa_header_banner.jpg"
              alt="Grievance Redressal"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/assets/images/why_choose_villa.jpg";
              }}
            />
          </div>
        </div>
      </section>

      <div className="mgh-info-container">
        <div className="mgh-two-col-layout">
          {/* Form */}
          <div className="mgh-form-card">
            <div className="mgh-form-card-header">
              <h3 style={{ fontSize: "18px", color: "#ea580c" }}>
                Grievance Officer Complaint Form
              </h3>
              <p style={{ color: "#64748b", fontSize: "13px" }}>
                Submit formal notices or consumer grievances directly to our compliance department.
              </p>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="mgh-form-group-item">
                <label>Your Name *</label>
                <div className="mgh-form-input-wrap">
                  <FiUser className="mgh-form-input-icon" />
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter your full name"
                    className="mgh-form-input"
                    required
                  />
                </div>
              </div>

              <div className="mgh-form-group-item">
                <label>Your Email ID *</label>
                <div className="mgh-form-input-wrap">
                  <FiMail className="mgh-form-input-icon" />
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                    className="mgh-form-input"
                    required
                  />
                </div>
              </div>

              <div className="mgh-form-group-item">
                <label>Your Contact Number *</label>
                <div className="mgh-form-input-wrap">
                  <FiPhone className="mgh-form-input-icon" />
                  <input
                    type="tel"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    placeholder="Enter 10-digit mobile number"
                    className="mgh-form-input"
                    required
                  />
                </div>
              </div>

              <div className="mgh-form-group-item">
                <label>URL of Reported Page *</label>
                <div className="mgh-form-input-wrap">
                  <FiLink className="mgh-form-input-icon" />
                  <input
                    type="url"
                    name="pageUrl"
                    value={formData.pageUrl}
                    onChange={handleChange}
                    placeholder="https://www.mygoldenhomes.com/..."
                    className="mgh-form-input"
                    required
                  />
                </div>
              </div>

              <div className="mgh-form-group-item">
                <label>Nature of Grievance *</label>
                <select
                  name="reason"
                  value={formData.reason}
                  onChange={handleChange}
                  className="mgh-form-select"
                >
                  <option value="Copyright or Intellectual Property Infringement">Copyright or Intellectual Property Infringement</option>
                  <option value="Incorrect Property Details or False Pricing">Incorrect Property Details or False Pricing</option>
                  <option value="Unauthorized Broker / Impersonation">Unauthorized Broker / Impersonation</option>
                  <option value="Consumer Service Deficiency">Consumer Service Deficiency</option>
                  <option value="Defamatory or Offensive Content">Defamatory or Offensive Content</option>
                  <option value="Other">Other Legal or Regulatory Matter</option>
                </select>
              </div>

              <div className="mgh-form-group-item">
                <label>Detailed Description of Grievance *</label>
                <textarea
                  name="details"
                  value={formData.details}
                  onChange={handleChange}
                  placeholder="Please state facts and reference details..."
                  className="mgh-form-textarea"
                  rows={4}
                  required
                />
              </div>

              <button
                type="submit"
                className="mgh-btn-submit-primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <span>Registering Grievance...</span>
                ) : (
                  <>
                    <FiSend />
                    <span>Submit Grievance</span>
                  </>
                )}
              </button>
            </form>
          </div>

          {/* Right Info Box */}
          <div>
            <div
              style={{
                background: "#ffffff",
                border: "1px solid #e2e8f0",
                borderRadius: "12px",
                padding: "20px",
                marginBottom: "20px",
                boxShadow: "0 4px 12px rgba(15, 23, 42, 0.05)",
              }}
            >
              <h4 style={{ margin: "0 0 10px 0", fontSize: "16px", fontWeight: "700", color: "#0f172a" }}>
                Grievance Officer Details
              </h4>
              <p style={{ margin: "0 0 8px 0", fontSize: "13px", color: "#475569" }}>
                <strong>Name:</strong> Grievance Redressal Desk
              </p>
              <p style={{ margin: "0 0 8px 0", fontSize: "13px", color: "#475569" }}>
                <strong>Address:</strong> My Golden Homes Pvt. Ltd., Begumpet, Hyderabad, Telangana - 500016
              </p>
              <p style={{ margin: "0 0 8px 0", fontSize: "13px", color: "#475569" }}>
                <strong>Email:</strong> <a href="mailto:grievance@mygoldenhomes.com" style={{ color: "#0284c7" }}>grievance@mygoldenhomes.com</a>
              </p>
              <p style={{ margin: 0, fontSize: "13px", color: "#475569" }}>
                <strong>Response Window:</strong> Within 48 hours of receipt.
              </p>
            </div>

            <div
              style={{
                background: "#f0fdf4",
                border: "1px solid #bbf7d0",
                borderRadius: "12px",
                padding: "18px 20px",
              }}
            >
              <div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "8px" }}>
                <FiCheckSquare style={{ color: "#16a34a", fontSize: "18px" }} />
                <h4 style={{ margin: 0, fontSize: "15px", fontWeight: "700", color: "#166534" }}>
                  Consumer Protection Commitment
                </h4>
              </div>
              <p style={{ margin: 0, fontSize: "12.5px", color: "#14532d", lineHeight: "1.5" }}>
                My Golden Homes strives to address all customer concerns in a fair, time-bound, and transparent manner.
              </p>
            </div>
          </div>
        </div>

        <ContactStrip customEmail="grievance@mygoldenhomes.com" />
      </div>

      <Footer />
    </div>
  );
};

export default Grievance;